import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import useSubmitKyc from '../../../../hooks/dashboard/settings/useSubmitKyc';
import {
  KycDirectorTwoDataType,
  kycDirectorTwoInitialValues,
  KycDirectorTwoSchema,
} from '../../../../models/dashboard/configuration/kycDirectorTwo';
import { kycInformationActions } from '../../../../redux/slices/kycInformationSlice';
import { useAppDisPatch } from '../../../../redux/store';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import PreviousSubmitBtn from '../../../Button/PreviousSubmitBtn';
import CustomSelectField from '../../../FormCom/CustomSelectField';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TextInputField } from '../../../FormCom/FormField';
import SingleDocumentUploadField from '../../../FormCom/SingleDocumentUploadField';

const directorOneIdentificationTypeOptions: Record<string, string> = {
  'National Identification Number (NIN)': 'NIN',
  'International Passport': 'Passport',
  'Drivers License': 'DriversLicense',
};

const DirectorTwoKycForm = () => {
  const dispatch = useAppDisPatch();

  const { submitKyc, loading } = useSubmitKyc();

  const [submitHookTrigger, setSubmitHookTrigger] = useState(false);

  useEffect(() => {
    if (submitHookTrigger) {
      submitKyc();
      setSubmitHookTrigger(false);
    }
    // eslint-disable-next-line
  }, [submitHookTrigger]);

  const handleSkipDirectorTwo = () => {
    // Clear any partial Director Two data
    dispatch(
      kycInformationActions.setKycDirectorTwoSlider({
        directorTwoName: undefined,
        directorTwoIdentificationType: undefined,
        directorTwoId: undefined,
      }),
    );
    setSubmitHookTrigger(true);
  };

  const onSubmit = (value: KycDirectorTwoDataType) => {
    const {
      // taxIdentificationNumber,
      directorTwoName,
      directorTwoIdentificationType,
      directorTwoId,
    } = value;

    // Check if any field is filled
    const hasAnyData =
      directorTwoName ||
      directorTwoIdentificationType ||
      (directorTwoId && directorTwoId.length > 0);

    if (!hasAnyData) {
      // No data provided, skip Director Two
      handleSkipDirectorTwo();
      return;
    }

    const validIdentificationDocument = (directorTwoId ?? []).filter(
      (file): file is File => file instanceof File,
    );

    if (
      validIdentificationDocument.length > 0 &&
      directorTwoName &&
      directorTwoIdentificationType
    ) {
      dispatch(
        kycInformationActions.setKycDirectorTwoSlider({
          directorTwoName,
          directorTwoIdentificationType:
            directorOneIdentificationTypeOptions[directorTwoIdentificationType],
          directorTwoId: validIdentificationDocument,
        }),
      );
      setSubmitHookTrigger(true);
    }
  };

  return (
    <Container>
      <FormComponent
        initialValues={kycDirectorTwoInitialValues}
        schema={KycDirectorTwoSchema}
        onSubmit={onSubmit}
        className={'small-gap'}
      >
        {/* <TaxIdInputField
          label='Business Tax Identification Number (TIN)'
          name='taxIdentificationNumber'
          id='taxIdentificationNumber'
          type='Business Tax Identification Number (TIN)'
          placeholder='TIN Number'
        /> */}

        {/* <OptionalLabel>Director 2 (Optional)</OptionalLabel> */}

        <TextInputField
          label='Name of Director 2'
          name='directorTwoName'
          id='directorTwoName'
          type='text'
          placeholder='Input your full name'
        />

        <CustomSelectField
          label='Identification'
          name='directorTwoIdentificationType'
          id='directorTwoIdentificationType'
          placeholder='Select ID type...'
          optionData={Object.keys(directorOneIdentificationTypeOptions)}
        />

        <SingleDocumentUploadField
          id='directorTwoId'
          name='directorTwoId'
          label='Upload ID of Director 2'
          placeholder='Drag your file to start uploading'
        />

        <FormButtonArea>
          <PreviousSubmitBtn>Go Back</PreviousSubmitBtn>
          <FormSubmitButton className='blue large' loading={loading}>
            Submit
          </FormSubmitButton>
        </FormButtonArea>
      </FormComponent>
    </Container>
  );
};

export default DirectorTwoKycForm;

const Container = styled.div`
  flex-direction: column;
  gap: 12px;
  display: flex;
`;

const FormButtonArea = styled.div`
  margin-top: 32px;
  display: grid;
  grid-template-columns: 120px auto;
  gap: 16px;
`;

// const OptionalLabel = styled.div`
//   font-size: 14px;
//   font-weight: 600;
//   color: #6b7280;
//   margin-bottom: -8px;
// `;
